<template>
  <div>
    <container-headline :headline="$t('global.schoolpartnership')" :col="6" />
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-6 form-group">
              <date-picker
                date-format="dd.mm.yy"
                :initial="firma.schulpartnerschaft.reservationsfensterVon"
                placeholder=" "
                :show-icon="true"
                :clearable="true"
                :disabled="!editable"
                :class="{ 'border-danger': nurBisGefuellt }"
                @update="(val) => (firma.schulpartnerschaft.reservationsfensterVon = val)"
              />
              <label :class="{ 'text-danger': nurBisGefuellt }">{{ $t("global.reservationWindowFrom") }}</label>
            </div>
            <div class="col-xl-6 form-group">
              <date-picker
                date-format="dd.mm.yy"
                :initial="firma.schulpartnerschaft.reservationsfensterBis"
                placeholder=" "
                :show-icon="true"
                :clearable="true"
                :disabled="!editable"
                :class="{ 'border-danger': nurVonGefuellt }"
                @update="(val) => (firma.schulpartnerschaft.reservationsfensterBis = val)"
              />
              <label :class="{ 'text-danger': nurVonGefuellt }">{{ $t("global.reservationWindowTill") }}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 form-group">
              <v-select
                v-model="firma.schulpartnerschaft.partnerhoefe"
                :options="betriebe"
                :disabled="!editable"
                multiple
                placeholder=""
                label="bezeichnung"
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>{{ $t("global.partnerFarms") }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline.vue";
import DatePicker from "@/components/Datepicker";
import AppApi from "@/api/AppApi";

const BETRIEB_ROLLE_ID = "1980A493F46";
const SUS_ID = "19730D16F14"; // Schüler:innen

export default {
  name: "Schulpartnerschaft",
  components: { ContainerHeadline, DatePicker },
  props: {
    editable: { type: Boolean, default: false },
    firma: { type: Object, required: true },
  },
  data() {
    return {
      betriebe: [],
    };
  },
  computed: {
    nurVonGefuellt() {
      return !!this.firma.schulpartnerschaft?.reservationsfensterVon &&
        !this.firma.schulpartnerschaft?.reservationsfensterBis;
    },
    nurBisGefuellt() {
      return !this.firma.schulpartnerschaft?.reservationsfensterVon &&
        !!this.firma.schulpartnerschaft?.reservationsfensterBis;
    },
  },
  mounted() {
    if (!this.firma.schulpartnerschaft) {
      this.$set(this.firma, "schulpartnerschaft", {
        reservationsfensterVon: null,
        reservationsfensterBis: null,
        partnerhoefe: [],
      });
    }
    AppApi.get("agriviva-firma/liste/", {
      params: { filterTyp: BETRIEB_ROLLE_ID, filterEinsatzherkunftJugendliche: SUS_ID, count: 9999 },
    }).then((response) => {
      this.betriebe = response.data
        .map((f) => ({ id: f.id, bezeichnung: f.name }))
        .sort((a, b) => (a.bezeichnung || "").localeCompare(b.bezeichnung || "", undefined, { sensitivity: "base" }));
      // Partnerhoefe re-hydrate damit v-select die Auswahl erkennt
      if (this.firma.schulpartnerschaft?.partnerhoefe?.length) {
        this.firma.schulpartnerschaft.partnerhoefe =
          this.firma.schulpartnerschaft.partnerhoefe.map(
            (ph) => this.betriebe.find((b) => b.id === ph.id) || ph
          );
      }
    });
  },
};
</script>
